import React from "react";
import { useStore } from "src/store";

import Ctx from "./Context";

// TODO: Refactor to use store hooks, and provide a hook instead of a HOC
export const withGPT = Comp => props => {
  const store = useStore("config");
  const { variant } = store("config");

  return <Ctx.Consumer>{gpt => (gpt.loaded ? <Comp {...props} gptCtx={gpt} variant={variant} /> : null)}</Ctx.Consumer>;
};
